export enum UnitTypeEnum {
	Litre = "UNIT_LITRES",
	LitresPerSecond = "UNIT_LITRES_PER_SEC",
	Second = "UNIT_SEC",
	Percent = "UNIT_PERCENT",
	LitresPerMinute = "UNIT_LITRES_PER_MIN",
	Millisecond = "UNIT_MILLISEC",
	Ratio = "UNIT_RATIO",
	Kilopascal = "UNIT_KPALS",
	LitresPerMetreSquared = "UNIT_LITRES_PER_MSQ",
	LitresPerLitresPerSecond = "UNIT_LITRES_PER_LITRES_PER_SEC",
	BeatsPerMinute = "UNIT_BPM",
	MilligramsPerMillilitre = "UNIT_MG_PER_ML",
	Minute = "UNIT_MINUTE",
	MillilitresOfCarbonMonoxidePerMinutePerMillimetreOfMercury = "UNIT_DLCO_TRADITIONAL",
	MillimolePerMinutePerKilopascal = "UNIT_DLCO_SI",
	Millilitre = "UNIT_MILLILITRES",
	Kilograms = "UNIT_KILOGRAMS",
	Pounds = "UNIT_POUNDS",
	Inches = "UNIT_INCHES",
	Centimetres = "UNIT_CENTIMETRES",
	MillimetreOfMercury = "UNIT_MILLIMETRE_OF_MERCURY",
	Millivolts = "UNIT_MILLIVOLTS",
	MillimolesPerLitre = "UNIT_MILLIMOLES_PER_LITRE",
	MilligramPerDecilitre = "UNIT_MILLIGRAMS_PER_DECILITRE",
	MillilitresOfCarbonMonoxidePerMinutePerMillimetreOfMercuryPerLitre = "UNIT_KCO_TRADITIONAL",
	MillimolePerMinutePerKilopascalPerLitre = "UNIT_KCO_SI",
	Years = "UNIT_YEARS",
}